export default __webpack_public_path__ + "static/media/feature-left-2.d28ccaa1.png";